import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { DATE_REDUCER_KEY, type DateStore } from './dateTypes';

const initialState: DateStore = {
  currentDate: DateTime.local().toISODate() ?? new Date().toISOString().split('T')[0], // If for some crazy reason luxon fails (the types indicate it can), fallback to normal iso string
};

const slice = createSlice({
  name: DATE_REDUCER_KEY,
  initialState,
  reducers: {
    updateCurrentDate(state, { payload }: PayloadAction<string>) {
      state.currentDate = payload;
    },
  },
});

export default slice.reducer;
export const dateActions = slice.actions;
